<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
    <UPDATE  ref="childUpdateSwitchCode"  @submit="submitSwitchCode" :updateData="updateSwitchCodeData"></UPDATE>
    <UPDATE  ref="childUpdateStatus"  @submit="submitStatus" :updateData="updateStatusData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '../components/page/table.vue'
  import FORM from '../components/page/form.vue'
  import UPDATE from '../components/page/update.vue'
  import URL from '@/views/mis/util/url'
  import Qs from 'qs'
  import axios from 'axios'
  let status = {0: "关闭", 1: "开启"};
  let device = {"IOS": "IOS", "Android": "安卓"};
  let switchCode = {"RONGXIN": "融信", "FACEID": "FACE++", "GLAD": "羽山"};
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    methods: {
      checkbox(row){
        this.deleteIds = row.map(key => key.id).join(",");
      },
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "update"){
          this.$refs.childUpdate.open(row);
        } else if(clickName == "delete"){
            this.$axios.get(URL.face.configdel+"?id="+row.id).then(res=> {
                if (res.code == 0) {
                    this.$message.success(window.$t('mis.faceConfig.submitSuccess'));
                    this.$refs.childTable.defaultGetData(this.queryData);
                }
            });
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName || window.$t('mis.bt.query') == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultQueryData(data);
        }else if(window.$t('mis.bt.add') == clickName){
          this.$refs.childUpdate.open();
        }else if(window.$t('mis.bt.batchUpdateSwitchCode') == clickName){
          if(this.deleteIds == "")
            this.$message.info(window.$t('mis.faceConfig.needSelectRecord'));
          else
            this.$refs.childUpdateSwitchCode.open();
        }else if(window.$t('mis.bt.batchUpdateStatus') == clickName){
          if(this.deleteIds == "")
            this.$message.info(window.$t('mis.faceConfig.needSelectRecord'));
          else
            this.$refs.childUpdateStatus.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        //根据是否包含id更新还是添加
        this.dataChanage(URL.face.configEdit,model,res => {
            if (res.code == 0){
                this.$refs.childUpdate.close();
                this.$message.success(window.$t('mis.rewardDealList.confirmSuccess'));
                this.$refs.childTable.defaultGetData(this.queryData);
            }else{
                this.$message.success(window.$t('mis.rewardDealList.confirmFail'));
            }
        })
      },
      submitSwitchCode(model){
        //根据已选id去更新
        model.ids = this.deleteIds;
        this.dataChanage(URL.face.switchCodeEdit,model,res => {
            if (res.code == 0){
                this.$refs.childUpdateSwitchCode.close();
                this.$message.success(window.$t('mis.rewardDealList.confirmSuccess'));
                this.$refs.childTable.defaultGetData(this.queryData);
            }else{
                this.$message.success(window.$t('mis.rewardDealList.confirmFail'));
            }
        })
      },
      submitStatus(model){
        //根据已选id去更新
        model.ids = this.deleteIds;
        this.dataChanage(URL.face.statusEdit,model,res => {
            if (res.code == 0){
                this.$refs.childUpdateStatus.close();
                this.$message.success(window.$t('mis.rewardDealList.confirmSuccess'));
                this.$refs.childTable.defaultGetData(this.queryData);
            }else{
                this.$message.success(window.$t('mis.rewardDealList.confirmFail'));
            }
        })
      },
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {

        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      }
    },
    data () {
      return {
        deleteIds:"",
        queryData:{},
        /*新增或更新*/
        updateData:{
          cols:[
                          { title: 'id', field: 'id', hidden: true},
                          { title: window.$t('mis.faceConfig.device'), field: 'device', type: 3, optionList: device, data: 'IOS'},
                          { title: window.$t('mis.faceConfig.channel'), field: 'channel', placeholder: window.$t('mis.faceConfig.channelDesc'), hidden: (model,col)=>{
                              return model.id?true:false;
                            }},
                          { title: window.$t('mis.faceConfig.version'), field: 'version', placeholder: window.$t('mis.faceConfig.versionDesc'), hidden: (model,col)=>{
                              return model.id?true:false;
                            }},
                          { title: window.$t('mis.faceConfig.switchCode'), field: 'switchCode', type: 3, optionList: switchCode, data: 'RONGXIN'},
                          { title: window.$t('mis.faceConfig.status'), field: 'status', type: 3, optionList: status, data: 1, isNumber: true},
          ]
        },
        /*批量修改通道*/
        updateSwitchCodeData:{
          modelName: '批量修改通道',
          cols:[
                          { title: window.$t('mis.faceConfig.switchCode'), field: 'switchCode', type: 3, optionList: switchCode, data: 'RONGXIN'},
          ]
        },
        /*批量修改状态*/
        updateStatusData:{
          modelName: '批量修改状态',
          cols:[
                          { title: window.$t('mis.faceConfig.status'), field: 'status', type: 3, optionList: status, data: 1, isNumber: true},
          ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
                          { title: window.$t('mis.faceConfig.device'), field: 'device', type: 2, optionList: device},
                          { title: window.$t('mis.faceConfig.channel'), field: 'channel'},
                          { title: window.$t('mis.faceConfig.switchCode'), field: 'switchCode', type: 2, optionList: switchCode},
                          { title: window.$t('mis.faceConfig.version'), field: 'version'},
                          { click: window.$t('mis.bt.query')},
                          { click: window.$t('mis.bt.add')},
                          { click: window.$t('mis.bt.batchUpdateSwitchCode'), auth: 'mis:faceConfig:batchupdate:switchcode'},
                          { click: window.$t('mis.bt.batchUpdateStatus'), auth: 'mis:faceConfig:batchupdate:status'}
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.face.configList, //请求路径和参数
          selection: true,
          sequence: true,
          cols: [
                          { title: window.$t('mis.faceConfig.channel'), field: 'channel'},
                          { title: window.$t('mis.faceConfig.version'), field: 'version'},
                          { title: window.$t('mis.faceConfig.device'), field: 'device', render: (data, full) => {
                                  return device[data] || "";
                              }
                          },
                          { title: window.$t('mis.faceConfig.switchCode'), field: 'switchCode', type: 2, render: (data, full) => {
                                  return switchCode[data] || "";
                              }
                          },
                          { title: window.$t('mis.faceConfig.status'), field: 'status', render: (data, full) => {
                                  return status[data] || "";
                              }
                          },
                          { title: window.$t('mis.faceConfig.createDate'), field: 'createDate'},
                          { title: window.$t('mis.faceConfig.createUser'), field: 'createUser'},
                          { title: window.$t('mis.faceConfig.updateUser'), field: 'updateUser'},
                          { title: window.$t('mis.faceConfig.updateDate'), field: 'updateDate'},
                          { title: window.$t('mis.bt.operation'), btnClick:[
                              { name:window.$t('mis.bt.delete'), click:"delete", auth:"mis:faceConfig:delete", type:"primary", icon:"el-icon-delete"},
                              { name:window.$t('mis.bt.edit'), click:"update", auth:"mis:faceConfig:edit", type:"primary", icon:"el-icon-edit"}
                          ]},
          ]
        }
      }
    }
  }
</script>
